import React from 'react';
import { Progress } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserGroup } from '@fortawesome/free-solid-svg-icons';
import { httpClient } from '@s20/services/httpClient';
import {
    createDataSource, createGridOptions, DataGrid, indexCellRenderer, LinkCellRenderer, TextFilterDefaults,
} from '../common/dataGrid/DataGrid';
import DataGridSelectFilter from '../common/dataGrid/DataGridSelectFilter';
import CommonContext, { agGridConstants, ApiRoutes, AppNavPaths } from '../Common';
import { PageHeading, PageWrap } from '../common/forms/FormElements';
import DataGridSelectFloatingFilter from '../common/dataGrid/DataGridSelectFloatingFilter';
import DataGridToolbar from '../common/dataGrid/DataGridToolbar';

class GroupIndex extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        };
    }

    componentDidMount() {
        return this.populateState();
    }

    populateState = async () => {
        const [roles] = await Promise.all([
            httpClient.js(ApiRoutes.typeAheads.roles()),
        ]);

        const gridOptions = createGridOptions(this);

        gridOptions.components = {
            selectFilter: DataGridSelectFilter,
            selectFloatingFilter: DataGridSelectFloatingFilter,
            nameRenderer: LinkCellRenderer,
        };

        gridOptions.columnDefs = [
            {
                flex: 0,
                width: 70,
                minWidth: 70,
                maxWidth: 70,
                headerName: '',
                valueGetter: 'node.id',
                sortable: false,
                cellRenderer: indexCellRenderer,
            },
            {
                colId: 'GroupName',
                sortable: true,
                headerName: 'Group Name',
                field: 'groupName',
                flex: 0,
                width: 300,
                minWidth: 300,
                filter: agGridConstants.columnFilterTypes.text,
                floatingFilter: true,
                filterParams: TextFilterDefaults,
                sort: { direction: 'asc', priority: 0 },
                cellRenderer: 'nameRenderer',
                cellRendererParams: {
                    to: (id) => `${AppNavPaths.Group}/${id}`,
                    nameField: 'groupName',
                    idField: 'id',
                    title: 'View this Group',
                },
            },
            {
                colId: 'ApplicationUserGroupRoles.ApplicationRoleId',
                sortable: false,
                headerName: 'Roles',
                field: 'rolesFlat',
                filter: 'selectFilter',
                floatingFilter: true,
                filterParams: {
                    labelText: 'Filter by type',
                    options: roles,
                    optionsLabel: 'label',
                    optionsValue: 'value',
                },
                floatingFilterComponent: 'selectFloatingFilter',
                floatingFilterComponentParams: {
                    suppressFilterButton: true,
                    options: roles,
                    optionsLabel: 'label',
                    optionsValue: 'value',
                },
                tooltipField: 'rolesFlat',
            },
            {
                colId: 'Code',
                sortable: false,
                headerName: 'Code',
                flex: 0,
                width: 140,
                minWidth: 140,
                maxWidth: 140,
                field: 'code',
                filter: agGridConstants.columnFilterTypes.text,
                floatingFilter: true,
                filterParams: TextFilterDefaults,
            },
            {
                sortable: false,
                headerName: 'Field Group?',
                field: 'isFieldGroup',
                flex: 0,
                width: 140,
                minWidth: 140,
                maxWidth: 140,
                cellRenderer: (params) => {
                    if (params.value === undefined) return '';

                    return params?.value ? 'Yes' : 'No';
                },
            },
            {
                sortable: false,
                headerName: 'Expanded Dispatching',
                field: 'expandedDispatching',
                tooltipField: 'expandedDispatching',
            },
        ];

        const ds = createDataSource(ApiRoutes.group.search(), gridOptions);

        this.setState({
            loading: false,
            gridOptions,
            dataSource: ds,
        });
    };

    render() {
        if (this.state.loading) return (<Progress />);
        const { rowData, gridOptions } = this.state;

        return (
            <PageWrap>
                <PageHeading>
                    <FontAwesomeIcon
                        icon={faUserGroup}
                        className="mr-2 text-muted"
                    />
                    <span>Groups</span>
                </PageHeading>
                <DataGridToolbar
                    entity="group"
                    gridApi={this.state.gridApi}
                    dataSource={this.state.dataSource}
                    onAdd={() => this.context.history.push(`${AppNavPaths.GroupNew}`)}
                    addLabel="Add Group"
                />
                <DataGrid
                    domLayout="normal"
                    rowData={rowData}
                    gridOptions={gridOptions}
                    gridStatus={this.state.gridStatus}
                />
            </PageWrap>
        );
    }
}
export default GroupIndex;
